import Home from "../../pages/coach";
import AboutUs from "../../pages/coach/auth/AboutUs";
import CoachSignUpStep1 from "../../pages/coach/auth/CoachSignUpStep1";
import CoachSignUpStep2 from "../../pages/coach/auth/CoachSignUpStep2";
import CoachSignUpStep3 from "../../pages/coach/auth/CoachSignUpStep3";
import ContactUs from "../../pages/coach/auth/ContactUs";
import ContactUsPage from "../../pages/coach/auth/ContactUsPage";
import Bootcamp from "../../pages/coach/bootcamp/Bootcamp";
import BootcampDetail from "../../pages/coach/bootcamp/BootcampDetail";
import BootcampList from "../../pages/coach/bootcamp/BootCampList";
import CoachDashboard from "../../pages/coach/Dashboard";
import Event from "../../pages/coach/events/Event";
import CoachWebinarDetails from "../../pages/coach/events/webinar/CoachWebinarDetails";
import WebinarDetail from "../../pages/coach/events/webinar/WebinarDetail";
import Subscription from "../../pages/coach/subscription";
import Webinar from "../../pages/coach/webinar";
import TakeChance from "../../pages/coach/webinar/take-a-chance";
import CoachWorkShopDetails from "../../pages/coach/workshop";
import WorkshopDetailsPage from "../../pages/coach/workshop/WorkshopDetailsPage";
import { ApplyBecomeCoach } from "../../pages/common/ApplyBecomeCoach";
import { BecomeCoach } from "../../pages/common/BecomeCoach";
import { CoachProfile } from "../../pages/common/CoachProfile";
import { FindCoach } from "../../pages/common/FindCoach";
import ForgotPassword from "../../pages/common/ForgotPassword";
import { FounderCoaching } from "../../pages/common/FounderCoaching";
import Login from "../../pages/common/Login";
import OTP from "../../pages/common/OTP";
import ResetPassword from "../../pages/common/ResetPassword";
import Signup from "../../pages/common/Signup";
import AddCoachWebinar from "../../pages/common/webinar/AddCoachWebinar";
import UpdateCoachWebinar from "../../pages/common/webinar/UpdateCoachWebinar";
import WebinarData from "../../pages/common/WebinarData";
import WebinarDataDetails from "../../pages/common/WebinarDataDetails";
import WebinarLandingPage from "../../pages/common/WebinarLandingPage";
import CoachAddWorkshopDetails from "../../pages/common/workshop/CoachAddWorkshopDetails";
import UpdateWorkshopDetails from "../../pages/common/workshop/UpdateWorkshopDetails";
import LeadershipCoaching from "../../pages/common/LeadershipCoaching";
import TeamTeaching from "../../pages/common/TeamTeaching";
import PerformanceCoaching from "../../pages/common/PerformanceCoaching";
import BusinessCoaching from "../../pages/common/BusinessCoaching";
import PersonalCoaching from "../../pages/common/PersonalCoaching";
import CoachSetting from "../../pages/coach/setting";
import Freelance from "../../pages/common/Freelance";
import NuGlowSubscription from "../../pages/common/NuGlowSubscription";
import NuForgeSubscription from "../../pages/common/NuForgeSubscription";
import NuStarSubscription from "../../pages/common/NuStarSubscription";
import FullJob from "../../pages/common/FullJob";
import CoachCoaching from "../../pages/coach/coaching";
import CoachResources from "../../pages/coach/resources";
import JobsList from "../../pages/find-a-job/JobsList";
import Learning from "../../pages/find-a-job/Learning";
import BoostedJob from "../../pages/common/BoostedJob";
import RecommendedOpporturnity from "../../pages/common/RecommendedOpporturnity";
import JobDetail from "../../pages/common/JobDetail";
import PostJob from "../../pages/common/PostJob";
import Profile from "../../pages/coach/Profile";
import Inbox from "../../pages/coach/Inbox";
import Wallet from "../../pages/coach/Wallet";
import MatchTalent from "../../pages/enterprises/MatchTalent";
import MatchTalentHire from "../../pages/enterprises/MatchTalentHire";
import NuvioWellness from "../../pages/common/NuvioWellness";
import Community from "../../pages/common/Community";
import Funding from "../../pages/common/Funding";
import FundingExploreProject from "../../pages/common/FundingExploreProject";
import FundingSubmitProject from "../../pages/common/FundingSubmitProject";
import FundingProjectFullDetail from "../../pages/common/FundingProjectFullDetail";
import CoachChangePasswordVerify from "../../pages/change-coach-password";
import SuccessCreatePassword from "../../pages/change-coach-password/SuccessCreatePassword";
import FailedCreatePassword from "../../pages/change-coach-password/FailedCreatePassword";

export const coachPaths = {
  Signup: "/sign-up",
  CoachSignUpStep1: "/coach-sign-up-step-1",
  CoachSignUpStep2: "/coach-sign-up-step-2",
  CoachSignUpStep3: "/coach-sign-up-step-3",
  OTP: "/otp",
  ResetPassword: "/reset-password",
  Login: "/login",
  ForgotPassword: "/forgot-password",
  // Webinar: "/",
  ContactUs: "/contact-us",
  AboutUs: "/about-us",
  BecomeCoach: "/become-a-coach",
  ApplyBecomeCoach: "/apply-become-a-coach",
  FindCoach: "/find-a-coach",
  CoachSubscription: "/coach-subscription",
  CoachDashboard: "/dashboard",
  FounderCoaching: "/Founder-coaching",
  CoachProfile: "/coach-profile/:id",
  Bootcamp: "/bootcamp",
  BootCampList: "/boot-camp",
  BootcampDetail: "/bootcamp-detail/:id",
  WebinarLandingPage: "/overview",
  WebinarData: "/webinar-events",
  WebinarDataDetails: "/webinar-detail",
  Event: "/coach/events",
  AddCoachWebinar: "/coach/add-webinar",
  AddCoachWorkShop: "/coach/add-workshop",
  WebinarDetail: "/coach/webinar-detail",
  UpdateWebinar: "/coach/update-webinar-detail",
  CoachWork_shopDetail: "/workshop-details",
  coachWorkshop_deats: "/coach/work-shop-deatsils",
  coachUpdateWorkShopDetails: "/coach/update-workshop",
  LeadershipCoaching: "/leadership-coaching",
  TeamTeaching: "/team-coaching",
  PerformanceCoaching: "/performance-coaching",
  BusinessCoaching: "/business-coaching",
  PersonalCoaching: "/personal-coaching",
  CoachSettings: "/coach/setting",
  freelance: "/freelancer-overview",
  NuGlowSubscription: "/NuGlow-subscription",
  NuForgeSubscription: "/NuForge-subscription",
  NuStarSubscription: "/NuStar-subscription",
  FullJob: "/full-job",
  coachCoaching: "/coach/coaching",
  coach_resources: "/coach/coaching-resources",
  find_job: "/find-job",
  Learning: "/learning",
  BoostedJob: "/boosted-job",
  RecommendedOpporturnity: "/recommended-opporturnity",
  JobDetail: "/job-detail",
  PostJob: "/post-jobs",
  Profile: "/coach/profile",
  Inbox: "/coach/inbox",
  Wallet: "/coach/wallet",
  MatchTalent: "/match-talent",
  HireTalent: "/hire-talent",
  NuvioWellness: "/nuvio-wellness",
  Community: "/community",
  Funding: "/funding",
  FundingExploreProject: "/funding-explore-project",
  FundingSubmitProject: "/funding-submit-project",
  FundingProjectFullDetail: "/funding-project-full-detail",
  // TakeChance:"/coach/take-a-chance",
  CoachChangePassword: '/coach/verify',
  CoachChangePasswordSuccess: '/coach/verify/success',
  CoachChangePasswordFailed: '/coach/verify/failed',
};

export const AllCoachRoutes = [
  {
    name: "Add Coach WorkShop",
    path: coachPaths?.AddCoachWorkShop,
    element: <CoachAddWorkshopDetails />,
    isPrivate: false,
  },
  {
    name: "Coach Change Password Verify",
    path: coachPaths?.CoachChangePassword,
    element: <CoachChangePasswordVerify />,
    isPrivate: false,
  },
  {
    name: "Success Create Password",
    path: coachPaths?.CoachChangePasswordSuccess,
    element: <SuccessCreatePassword />,
    isPrivate: false,
  },
  {
    name: "Failed Create Password",
    path: coachPaths?.CoachChangePasswordFailed,
    element: <FailedCreatePassword />,
    isPrivate: false,
  },
  {
    name: "JobList",
    path: coachPaths?.find_job,
    element: <JobsList />,
  },
  {
    name: "Learning",
    path: coachPaths?.Learning,
    element: <Learning />,
    isPrivate: false,
  },
  {
    name: "Coach Resources",
    path: coachPaths?.coach_resources,
    element: <CoachResources />,
    isPrivate: false,
  },
  {
    name: "Coach Coaching",
    path: coachPaths?.coachCoaching,
    element: <CoachCoaching />,
    isPrivate: false,
  },
  {
    name: "Coach Setting",
    path: coachPaths?.CoachSettings,
    element: <CoachSetting />,
    isPrivate: false,
  },
  {
    name: "Update Work shop Details",
    path: coachPaths?.coachUpdateWorkShopDetails,
    element: <UpdateWorkshopDetails />,
    isPrivate: false,
  },
  {
    name: "WorkshopDetailsPage",
    path: coachPaths?.coachWorkshop_deats,
    element: <WorkshopDetailsPage />,
    isPrivate: false,
  },
  // WorkshopDetailsPage
  {
    name: "Webinar Landing Page",
    path: coachPaths?.WebinarLandingPage,
    element: <WebinarLandingPage />,
    isPrivate: false,
  },
  {
    name: "Webinar Landing Page",
    path: coachPaths?.WebinarDataDetails,
    element: <WebinarDataDetails />,
    isPrivate: false,
  },
  {
    name: "Webinar Data",
    path: coachPaths?.WebinarData,
    element: <WebinarData />,
    isPrivate: false,
  },
  {
    name: "Home",
    path: coachPaths.Home,
    element: <Home />,
    isPrivate: false,
  },
  {
    name: "AboutUs",
    path: coachPaths.AboutUs,
    element: <AboutUs />,
    isPrivate: false,
  },
  {
    name: "Subscription",
    path: coachPaths?.CoachSubscription,
    element: <Subscription />,
    isPrivate: true,
  },
  {
    name: "Coach Dashboard",
    path: coachPaths?.CoachDashboard,
    element: <CoachDashboard />,
    isPrivate: true,
  },
  // {
  //   name: "Webinar",
  //   path: coachPaths.Webinar,
  //   element: <Webinar />,
  //   isPrivate: false,
  // },
  {
    name: "ContactUs",
    path: coachPaths.ContactUs,
    element: <ContactUsPage />,
    isPrivate: false,
  },
  {
    name: "Signup",
    path: coachPaths.Signup,
    element: <Signup />,
    isPrivate: false,
  },
  {
    name: "Login",
    path: coachPaths.Login,
    element: <Login />,
    isPrivate: false,
  },
  {
    name: "ForgotPassword",
    path: coachPaths.ForgotPassword,
    element: <ForgotPassword />,
    isPrivate: false,
  },
  {
    name: "OTP",
    path: coachPaths.OTP,
    element: <OTP />,
    isPrivate: false,
  },
  {
    name: "CoachSignUpStep1",
    path: coachPaths.CoachSignUpStep1,
    element: <CoachSignUpStep1 />,
    isPrivate: false,
  },
  {
    name: "CoachSignUpStep2",
    path: coachPaths.CoachSignUpStep2,
    element: <CoachSignUpStep2 />,
    isPrivate: false,
  },
  {
    name: "CoachSignUpStep3",
    path: coachPaths.CoachSignUpStep3,
    element: <CoachSignUpStep3 />,
    isPrivate: false,
  },
  {
    name: "ResetPassword",
    path: coachPaths.ResetPassword,
    element: <ResetPassword />,
    isPrivate: false,
  },
  {
    name: "BecomeCoach",
    path: coachPaths.BecomeCoach,
    element: <BecomeCoach />,
    isPrivate: false,
  },
  {
    name: "ApplyBecomeCoach",
    path: coachPaths.ApplyBecomeCoach,
    element: <ApplyBecomeCoach />,
    isPrivate: false,
  },
  {
    name: "FindCoach",
    path: coachPaths.FindCoach,
    element: <FindCoach />,
    isPrivate: false,
  },
  {
    name: "FounderCoaching",
    path: coachPaths.FounderCoaching,
    element: <FounderCoaching />,
    isPrivate: false,
  },
  {
    name: "CoachProfile",
    path: coachPaths.CoachProfile,
    element: <CoachProfile />,
    isPrivate: false,
  },
  {
    name: "Bootcamp",
    path: coachPaths.Bootcamp,
    element: <Bootcamp />,
    isPrivate: false,
  },
  {
    name: "Boot camp",
    path: coachPaths.BootCampList,
    element: <BootcampList />,
    isPrivate: false,
  },
  {
    name: "BootcampDetail",
    path: coachPaths.BootcampDetail,
    element: <BootcampDetail />,
    isPrivate: false,
  },
  {
    name: "Event",
    path: coachPaths.Event,
    element: <Event />,
    isPrivate: false,
  },
  {
    name: "AddCoachWebinar",
    path: coachPaths.AddCoachWebinar,
    element: <AddCoachWebinar />,
    isPrivate: false,
  },
  {
    name: "WebinarDetail",
    path: coachPaths.WebinarDetail,
    element: <CoachWebinarDetails />,
    isPrivate: false,
  },
  {
    name: "UpdateWebinar",
    path: coachPaths.UpdateWebinar,
    element: <UpdateCoachWebinar />,
    isPrivate: false,
  },
  {
    name: "Coach Work Shop Detail",
    path: coachPaths.CoachWork_shopDetail,
    element: <CoachWorkShopDetails />,
    isPrivate: false,
  },
  {
    name: "LeadershipCoaching",
    path: coachPaths.LeadershipCoaching,
    element: <LeadershipCoaching />,
    isPrivate: false,
  },
  {
    name: "TeamTeaching",
    path: coachPaths.TeamTeaching,
    element: <TeamTeaching />,
    isPrivate: false,
  },
  {
    name: "PerformanceCoaching",
    path: coachPaths.PerformanceCoaching,
    element: <PerformanceCoaching />,
    isPrivate: false,
  },
  {
    name: "BusinessCoaching",
    path: coachPaths.BusinessCoaching,
    element: <BusinessCoaching />,
    isPrivate: false,
  },
  {
    name: "PersonalCoaching",
    path: coachPaths.PersonalCoaching,
    element: <PersonalCoaching />,
    isPrivate: false,
  },
  {
    name: "freelance",
    path: coachPaths.freelance,
    element: <Freelance />,
    isPrivate: false,
  },
  {
    name: "NuGlowSubscription",
    path: coachPaths.NuGlowSubscription,
    element: <NuGlowSubscription />,
    isPrivate: false,
  },
  {
    name: "NuForgeSubscription",
    path: coachPaths.NuForgeSubscription,
    element: <NuForgeSubscription />,
    isPrivate: false,
  },
  {
    name: "NuStarSubscription",
    path: coachPaths.NuStarSubscription,
    element: <NuStarSubscription />,
    isPrivate: false,
  },
  {
    name: "FullJob",
    path: coachPaths.FullJob,
    element: <FullJob />,
    isPrivate: false,
  },
  {
    name: "BoostedJob",
    path: coachPaths.BoostedJob,
    element: <BoostedJob />,
    isPrivate: false,
  },
  {
    name: "RecommendedOpporturnity",
    path: coachPaths.RecommendedOpporturnity,
    element: <RecommendedOpporturnity />,
    isPrivate: false,
  },
  {
    name: "JobDetail",
    path: coachPaths.JobDetail,
    element: <JobDetail />,
    isPrivate: false,
  },
  {
    name: "PostJob",
    path: coachPaths.PostJob,
    element: <PostJob />,
    isPrivate: false,
  },
  {
    name: "Profile",
    path: coachPaths.Profile,
    element: <Profile />,
    isPrivate: false,
  },
  {
    name: "Inbox",
    path: coachPaths.Inbox,
    element: <Inbox />,
    isPrivate: false,
  },
  {
    name: "Wallet",
    path: coachPaths.Wallet,
    element: <Wallet />,
    isPrivate: false,
  },
  {
    name: "MatchTalent",
    path: coachPaths.MatchTalent,
    element: <MatchTalent />,
    isPrivate: false,
  },
  {
    name: "MatchTalentHire",
    path: coachPaths.HireTalent,
    element: <MatchTalentHire />,
    isPrivate: false,
  },
  {
    name: "NuvioWellness",
    path: coachPaths.NuvioWellness,
    element: <NuvioWellness />,
    isPrivate: false,
  },
  {
    name: "Community",
    path: coachPaths.Community,
    element: <Community />,
    isPrivate: false,
  },
  {
    name: "Funding",
    path: coachPaths.Funding,
    element: <Funding />,
    isPrivate: false,
  },
  {
    name: "FundingExploreProject",
    path: coachPaths.FundingExploreProject,
    element: <FundingExploreProject />,
    isPrivate: false,
  },
  {
    name: "FundingSubmitProject",
    path: coachPaths.FundingSubmitProject,
    element: <FundingSubmitProject />,
    isPrivate: false,
  },
  {
    name: "FundingProjectFullDetail",
    path: coachPaths.FundingProjectFullDetail,
    element: <FundingProjectFullDetail />,
    isPrivate: false,
  },
  // {
  //   name: "Coach Work Shop Detail",
  //   path: coachPaths.CoachWork_shopDetail,
  //   element: <Leade />,
  //   isPrivate: false,
  // },

  //  {
  //   name: "TakeChance",
  //   path: coachPaths.TakeChance,
  //   element: <TakeChance />,
  //   isPrivate: false,
  // },
];